import { Database } from '../db.ts';
import { StatusHistory } from './common/history.ts';
import { ProductData, ProductTypes } from './product.ts';

type DBPurchase = Database['public']['Tables']['purchases']['Row'];

export type PurchaseRawData = Omit<DBPurchase, 'stripe' | 'status' | 'status_history' | 'input_data'> & {
    stripe: PurchaseStripeData | null;
    status: PurchaseStatus;
    status_history?: StatusHistory<PurchaseStatus>
    input_data: PurchaseInputData;
};

export type PurchaseData = PurchaseRawData & {
    product: ProductData;
};

export type PurchaseStripeData = {
    customerId: string;
    sessionId?: string;
    clientSecret?: string;
};

export enum PurchaseStatus {
    Initiated = 'initiated',
    PaymentInProgress = 'payment_in_progress',
    PaymentFailed = 'payment_failed',
    PaymentSucceeded = 'payment_succeeded',
    PaymentRefunded = 'payment_refunded',
}

type PurchaseInputDataBase = {
    productSlug: string;
    email: string;
    username: string,
    phone: string,
    authorName: string;
    assetName: string;
    assetLink?: string;
    releaseDate?: string | null;
    notes?: string;
    promocode?: string | null;
};

export type PurchaseInputDataSpotify = PurchaseInputDataBase & {
    assetType: ProductTypes.Spotify;
};

export type PurchaseInputData = PurchaseInputDataSpotify;

export namespace PurchaseInputData {
    export type Types = PurchaseInputData['assetType'];

    export const ValidTypes: Types[] = [ProductTypes.Spotify];
}
